// Endpoint specs:
// https://www.dropbox.com/scl/fi/31nxogj0nap0jy842z4sg/Payment-Page.paper?dl=0&rlkey=sx4z963m428xpb3tpar5sb92y#:uid=421100453928993879758092&h2=Endpoint:-Request-Auth-Code

export const mockRequestAuthCodeResponse = {
  success: true,
};
